export default "__VITE_ASSET__DwcQYVN0__"